import React from 'react'
import {connect} from 'react-redux'
import Select from 'react-select';
import Titulo from '../comum/Titulo';
import buscarCidades from '../../actions/cidade/buscarCidades';
import {PERFIL_ADMIN} from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import CabecalhoRodapeTabela from '../comum/CabecalhoRodapeTabela';
import PaginacaoCidades from './PaginacaoCidades';
import BotoesPaginacaoCidades from './BotoesPaginacaoCidades';
import Cidade from './Cidade';
import {alterouPagina} from '../../util/filtros';
import ModalCadastrarCidade from './ModalCadastrarCidade';
import excluirCidade from '../../actions/cidade/excluirCidade';
import limparCidadeSelecionada from '../../actions/cidade/limparCidadeSelecionada';
import determinarPaginaAtualCidade from '../../actions/cidade/determinarPaginaAtualCidades';
import alterarRegistrosPorPaginaCidades from '../../actions/cidade/alterarRegistrosPorPaginaCidades';
import {estados} from '../../util/constantsUtil';
import {showSuccessMsg} from '../../util/messagesUtil';

export const CabecalhoTabela = () => (
    <div id="header-tabela" className="lista-tabela-dados">
        <div className="row cabecalho-desktop">
            <div className="col-lg-2 col-xl-2">ID</div>
            <div className="col-lg-4 col-xl-4">Nome</div>
            <div className="col-lg-4 col-xl-4">Estado</div>
            <div className="col-lg-2 col-xl-2">Ações</div>
        </div>
    </div>
);

const ModalConfirmacaoExclusao = ({excluir, cidade}) => (
    <div className="modal fade" id="modalConfirmacaoExclusaoCidade" tabIndex="-1" role="dialog"
         aria-labelledby="modalConfirmacao" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
                <div className="modal-body texto-centralizado">
                    <p>Deseja excluir a cidade <strong>{cidade ? cidade.nomeComUf : ''}?</strong></p>
                </div>
                <div className="modal-footer ">
                    <button id='cancelar' type="button" className="btn btn-outline-secondary"
                            data-dismiss="modal">Cancelar
                    </button>
                    <button id='excluir-cidade' type="button" className="btn btn-laranja float-left"
                            data-dismiss="modal"
                            onClick={() => excluir()}>Excluir
                    </button>
                </div>
            </div>
        </div>
    </div>);

export class PainelGerenciarCidades extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            parametros: {
                nome: '',
                uf: ''
            }
        };
    }

    componentDidMount() {
        this.props.buscarCidades(this.state.parametros, this.props.paginaAtual, this.props.registrosPorPagina);
    }

    componentDidUpdate(prevProps) {
        if (alterouPagina(this.props, prevProps)) {
            this.props.buscarCidades(this.state.parametros, this.props.paginaAtual, this.props.registrosPorPagina);
        }
    }

    alterarParametro(tipo, valor) {
        if (tipo === 'ESTADO') {
            this.setState({
                parametros: {
                    uf: valor,
                    nome: this.state.parametros.nome
                },
            })
        }

        if (tipo === 'NOME') {
            this.setState({
                parametros: {
                    uf: this.state.parametros.uf,
                    nome: valor
                },
            })
        }
    }

    buscar() {
        this.zerarPaginacao();
        this.props.buscarCidades(this.state.parametros, 1, 10);
    }

    handleChange(event) {
        this.alterarParametro('NOME', event.target.value)
    }

    exibirCampoBusca() {
        return (<React.Fragment>
            <div className="input-group mb-3 mt-3">
                <div className="col-12 col-sm-12 col-md-3 mb-3">
                    <div className="form-group">
                        <Select id="filtro-uf"
                                noOptionsMessage={() => ('Nenhuma opção encontrada')}
                                placeholder='Estados...'
                                options={estados.map(elemento => ({
                                    label: elemento.nome,
                                    value: elemento.uf
                                }))}
                                onChange={value => this.alterarParametro('ESTADO', value.value)}
                        />
                    </div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 mb-6">
                    <div className="form-group">
                        <input className="form-control form-control-md campo-busca" type="text" style={{height: 38}}
                               placeholder="Nome da Cidade" onChange={this.handleChange.bind(this)}/>
                    </div>
                </div>

                <div className="col-12 col-sm-9 col-md-2">
                    <button onClick={() => this.buscar()}
                            className='btn botaoLogar btn-laranja'>Buscar
                    </button>
                </div>
            </div>
        </React.Fragment>)
    }

    // eslint-disable-next-line class-methods-use-this
    exibirBotaoNovoEmpresa() {
        return (
            <div className="row">
                <div className="col-md-12">
                    <div className="text-right">
                        <button data-toggle="modal" data-target="#modalCadastrarCidade" className="btn btn-laranja"
                                onClick={() => this.props.limparCidadeSelecionada()}>
                            Nova Cidade
                        </button>
                    </div>
                </div>
            </div>)
    }

    exibir() {
        if (this.props.cidades && this.props.cidades.length) {
            return (<div className="col-12 conteudo-internas">
                    <CabecalhoRodapeTabela OpcoesPaginacao={PaginacaoCidades}
                                           BotoesPaginacao={BotoesPaginacaoCidades}>
                        <CabecalhoTabela/>
                        <div className="lista-table">
                            {this.exibirCidades()}
                        </div>
                    </CabecalhoRodapeTabela>
                </div>
            )
        }
        return <div>Nenhuma cidade encontrada para o parâmetro informados.</div>;
    }

    exibirCidades() {
        if (this.props.cidades) {
            return this.props.cidades.map(cidade => <Cidade key={cidade.id} cidade={cidade}/>)
        }
    }

    zerarPaginacao() {
        this.props.determinarPaginaAtualCidade(1);
        this.props.alterarRegistrosPorPaginaCidades(10)
    }

    excluir() {
        this.props.excluirCidade(this.props.cidade.id).then(() => {
            showSuccessMsg('Cidade excluída com sucesso');
            this.buscar();
        })
    }


    render() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
                <div>
                    <div className="row internas">
                        <Titulo texto="Gerenciar Cidades" urlRetorno="/"/>
                        <div className='col-12 conteudo-internas conteudo-painel area-btn-filtro-painel'>
                            {this.exibirCampoBusca()}
                            {this.exibirBotaoNovoEmpresa()}
                            <div className="lista-table">
                                {this.exibir()}
                            </div>
                        </div>
                    </div>
                </div>
                <ModalCadastrarCidade parametros={this.state.parametros}/>
                <ModalConfirmacaoExclusao excluir={this.excluir.bind(this)} cidade={this.props.cidade}/>
            </Autorizacao>
        )
    }
}


export const mapStateToProps = state => (
    {
        cidades: state.cidades.cidades,
        paginaAtual: state.paginaAtualCidade,
        registrosPorPagina: state.registrosPorPaginaCidade,
        cidade: state.cidade
    });


export default connect(mapStateToProps, {
    buscarCidades,
    excluirCidade,
    limparCidadeSelecionada,
    determinarPaginaAtualCidade,
    alterarRegistrosPorPaginaCidades
})(PainelGerenciarCidades)
